module.exports = __webpack_public_path__ + "static/offline-0f8be6492a6426ddd62c8bdbd0565f20.mp4";